import { Button, Pagination } from 'react-bootstrap';
import styled from 'styled-components';

export const aepColors = {
  'powder-blue': '#deecfd',
  'dark-gray': '#4a4a4a',
  'icon-gray': '#9e9fa1',
  'button-primary-standard': '#025a95',
  primary: '#013a6b',
  secondary: '#4a4a4a',
  'mid-gray': '#dcdcdc',
  'light-gray': '#f3f3f3',
  'colors-primary-grayscale-01-white': '#fff',
  'colors-primary-blues-brand-blue': '#009cde',
  'colors-primary-blue-50': '#e4f4fd',
  'colors-primary-blue-300': '#1f74b9',
  'colors-primary-blue-700': '#013a6b',
  'ui-elements-icons-icon-blue': '#35b2e2',
};

const handleColorType = (color) => {
  switch (color) {
    case 'primary':
      return ` background-color: ${aepColors['button-primary-standard']};
        border-color:${aepColors['button-primary-standard']};
        &:hover{
            background-color: ${aepColors['colors-primary-blue-700']};
        border-color:${aepColors['colors-primary-blue-700']};
        }
        `;
    case 'secondary':
      return ` background-color: ${aepColors['icon-gray']};
        border-color:${aepColors['icon-gray']};
        &:hover{
            background-color: ${aepColors['secondary']};
        border-color:${aepColors['secondary']};
        }`;
    default:
      return 'color: #000; background: #eee;';
  }
};

export const StyledButton = styled(Button)`
  width: auto;
  min-width: 100px;
  margin: 5px;
  ${({ btnType }) => handleColorType(btnType)};
`;

export const StyledPagination = styled(Pagination)`
  .active > .page-link,
  .page-link.active {
    background-color: ${aepColors['button-primary-standard']};
    border-color: ${aepColors['light-gray']};
  }
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto auto auto;
`;

export const GridItems = styled.div``;

export const ButtonContainer = styled.div`
  float: right;
`;

export const MapWrapper = styled.div`
.leaflet-control-attribution.leaflet-control {
  display: none;
}
`

export const LoginContainer = styled.div`
display: flex;
flex-direction:column;
align-items: center;
`

export const ColContainer = styled.div`    
display: flex;
height:80vh;
flex-direction: column;
justify-content: center;
align-items: center;
`
